import * as _ from 'lodash';
import type { FunctionComponent } from 'react';
import Relationships from './Relationships';
import type { MinimalDependencyLock, Path } from './useDependencyPaths';

const MAX_PATHS = 30;

type RelationshipListProps = {
  paths: Path[][];
  projectTitle: string | null;
  dependencyLocks: Record<string, MinimalDependencyLock>;
};

const RelationshipList: FunctionComponent<RelationshipListProps> = ({
  paths,
  projectTitle,
  dependencyLocks,
}) => {
  const pathsByLocator = _.groupBy(paths, path => path[0]?.locator);
  return (
    <>
      <p>
        <b>{projectTitle}</b> is included in {paths.length >= MAX_PATHS ? 'at least' : null}{' '}
        {paths.length} ways:
      </p>
      {Object.entries(pathsByLocator).map(([baseRev, groupedPaths]) =>
        <Relationships
          baseRevision={baseRev}
          groupedPaths={groupedPaths}
          projectTitle={projectTitle}
          dependencyLocks={dependencyLocks}
        />,
      )}
    </>
  );
};

export default RelationshipList;
